import { render, staticRenderFns } from "./InventoryDetailsReport.vue?vue&type=template&id=b1e04fbc&scoped=true&"
import script from "./InventoryDetailsReport.vue?vue&type=script&lang=js&"
export * from "./InventoryDetailsReport.vue?vue&type=script&lang=js&"
import style0 from "./InventoryDetailsReport.vue?vue&type=style&index=0&id=b1e04fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e04fbc",
  null
  
)

export default component.exports